module.exports = __webpack_public_path__ + "img/Memberkit-2-pt.18cdf1df.png";